/**
 * Footer Newsletter Form – Klaviyo API v3 Subscribe
 */

(function () {
  'use strict';

  const KLAVIYO_API_VERSION = '2026-01-15';
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  async function klaviyoSubscribe({ companyId, listId, email, firstName }) {
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`;

    const profileAttributes = { email };
    if (firstName) profileAttributes.first_name = firstName;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_API_VERSION
      },
      body: JSON.stringify(payload)
    });

    if (response.status === 202 || response.ok) {
      return { success: true };
    }

    let errorMessage = `HTTP ${response.status}`;
    try {
      const json = await response.json();
      if (json.errors && json.errors[0]) {
        errorMessage = json.errors[0].detail || json.errors[0].title || errorMessage;
      }
    } catch (_) {}

    return { success: false, error: errorMessage };
  }

  function showError(wrapper, input, errorEl, message) {
    errorEl.textContent = message;
    input.classList.add('invalid');
  }

  function clearError(input, errorEl) {
    errorEl.textContent = '';
    input.classList.remove('invalid');
  }

  function setLoading(btn, isLoading) {
    btn.disabled = isLoading;
  }

  function initForm(wrapper) {
    const listId    = wrapper.dataset.klaviyoList;
    const companyId = wrapper.dataset.klaviyoCompany;

    if (!listId || !companyId) return;

    const firstNameInput = wrapper.querySelector('input[autocomplete="given-name"]');
    const input          = wrapper.querySelector('input[type="email"]');
    const btn            = wrapper.querySelector('[data-newsletter-submit]');
    const errorEl        = wrapper.querySelector('[data-error]');
    const successEl      = wrapper.querySelector('[data-newsletter-success]');

    const msgInvalidEmail = wrapper.dataset.msgInvalidEmail || 'Please enter a valid email address.';
    const msgError        = wrapper.dataset.msgError        || 'Something went wrong. Please try again.';

    if (!input || !btn) return;

    input.addEventListener('input', () => clearError(input, errorEl));

    async function handleSubmit() {
      const email     = input.value.trim();
      const firstName = firstNameInput ? firstNameInput.value.trim() : '';

      if (!email || !EMAIL_REGEX.test(email)) {
        showError(wrapper, input, errorEl, msgInvalidEmail);
        input.focus();
        return;
      }

      clearError(input, errorEl);
      setLoading(btn, true);

      const result = await klaviyoSubscribe({ companyId, listId, email, firstName });

      setLoading(btn, false);

      if (result.success) {
        input.value = '';
        if (firstNameInput) firstNameInput.value = '';
        wrapper.querySelector('.field__wrapper').hidden = true;
        if (successEl) successEl.hidden = false;
        document.dispatchEvent(new CustomEvent('footer_newsletter:subscribed', {
          bubbles: true,
          detail: { email, firstName, listId }
        }));
      } else {
        showError(wrapper, input, errorEl, msgError);
      }
    }

    btn.addEventListener('click', handleSubmit);
    [input, firstNameInput].filter(Boolean).forEach((el) => {
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSubmit();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.footer__newsletter.newsletter-form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
